import { useMemo } from 'react';
import { useOrgFeatures } from './useOrgFeatures';
import { generatePayPeriods, findCurrentPayPeriodIndex } from '../admin/constants/timeTrackingConstants';

/**
 * This organization's pay periods around today, on its own pay period grid
 * (Settings > Pay period). `configured` is false until an admin sets one up;
 * `periods` is then empty and pages say so rather than guess.
 */
export function usePayPeriods() {
  const { payPeriodGrid, loading } = useOrgFeatures();
  const periods = useMemo(() => generatePayPeriods(payPeriodGrid), [payPeriodGrid]);
  const currentIndex = useMemo(() => findCurrentPayPeriodIndex(periods), [periods]);
  return { periods, currentIndex, grid: payPeriodGrid, configured: !!payPeriodGrid?.configured, loading };
}

export default usePayPeriods;
